import { useState, useEffect } from "react";
import { api } from "../api";
import { useToast } from "../components/Toast.jsx";
import { useAuth } from "../contexts/AuthContext.jsx";

// Привязка точек (locations) к филиалам YClients (company_id) + синк по кнопке, который
// материализует товары/категории филиала прямо в реальный каталог (products/product_groups), с
// location = имя точки.
function LocationBindings() {
  const { user } = useAuth();
  const isCentral = !!user?.isCentral;
  const [locations, setLocations] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [pendingCompany, setPendingCompany] = useState({});
  const [savingId, setSavingId] = useState(null);
  const [syncingAll, setSyncingAll] = useState(false);
  const { showToast, ToastElement } = useToast();

  // Independent requests, independent .then's — bundling these into one Promise.all meant the
  // fast local locations data sat unrendered ("Точек пока нет") until the slower real YClients
  // companies call came back, even though it has nothing to do with them.
  const load = () => {
    api.listLocations().then(setLocations).catch(() => {});
    api.getYclientsCompanies().then(setCompanies).catch(() => {});
  };
  useEffect(load, []);

  const handleSave = async (locationId) => {
    setSavingId(locationId);
    try {
      await api.setYclientsLocationCompany(locationId, pendingCompany[locationId] || null);
      showToast("Привязка сохранена");
      load();
    } catch {
      showToast("Ошибка сохранения");
    } finally {
      setSavingId(null);
    }
  };

  const handleSyncAll = async () => {
    setSyncingAll(true);
    try {
      const { results } = await api.syncYclientsAllLocations();
      const ok = results.filter(r => !r.error).length;
      showToast(`Готово: ${ok}/${results.length} точек синхронизировано`);
    } catch {
      showToast("Ошибка синхронизации");
    } finally {
      setSyncingAll(false);
    }
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <div className="admin-header">
        <h3 className="admin-title" style={{ fontSize: 15 }}>Привязка точек к филиалам YClients</h3>
        {isCentral && (
          <button className="btn btn-primary btn-sm" onClick={handleSyncAll} disabled={syncingAll || locations.length === 0}>
            {syncingAll ? "Синхронизация…" : "Синхронизировать точки"}
          </button>
        )}
      </div>
      {!isCentral && <p className="text-xs" style={{ color: "#94A3B8", marginBottom: 8 }}>Привязка и синхронизация настраиваются только на центральном сервере.</p>}
      <table className="admin-table">
        <thead>
          <tr><th>Точка</th><th>Филиал YClients</th><th></th></tr>
        </thead>
        <tbody>
          {locations.length === 0 ? (
            <tr><td colSpan={3} className="text-xs text-slate-400">Точек пока нет — заведите их в «Конфигурации полей»</td></tr>
          ) : (
            locations.map(loc => {
              const current = pendingCompany[loc.id] ?? (loc.yclients_company_id || "");
              return (
                <tr key={loc.id}>
                  <td>{loc.name}</td>
                  <td>
                    {isCentral ? (
                      <select
                        className="admin-input"
                        value={current}
                        onChange={e => setPendingCompany(p => ({ ...p, [loc.id]: e.target.value }))}
                      >
                        <option value="">— не привязано —</option>
                        {companies.map(c => (
                          <option key={c.id} value={c.id}>{c.title}{c.city ? ` (${c.city})` : ""}</option>
                        ))}
                      </select>
                    ) : (
                      <span className="text-xs text-slate-500">{loc.yclients_company_id || "— не привязано —"}</span>
                    )}
                  </td>
                  {isCentral && (
                    <td>
                      <button className="btn btn-ghost btn-sm" onClick={() => handleSave(loc.id)} disabled={savingId === loc.id}>
                        {savingId === loc.id ? "..." : "Сохранить"}
                      </button>
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      <ToastElement />
    </div>
  );
}

export default function YClientsPage() {
  return (
    <div className="admin-page">
      <LocationBindings />
    </div>
  );
}
